import dynamic from 'next/dynamic';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import infoIcon from '@/public/images/icons/info-circle.svg';

import style from './style.module.scss';

const SizeCardModal = dynamic(
  () => import('../../self-storage-moving/size-card')
);
const SizeHelpButton = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div
        className={style.sizeHelpBtnContainer}
        onClick={() => setShowModal(true)}
      >
        <img src={infoIcon.src} alt="info-icon" />
        <div className={style.title}>
          <FormattedMessage id="Size Help" />
        </div>
      </div>
      {showModal && (
        <SizeCardModal
          open={showModal}
          onClose={() => {
            setShowModal(false);
          }}
        />
      )}
    </>
  );
};

export default SizeHelpButton;
